export default __webpack_public_path__ + "static/media/members.d709920d.svg";